export type TablePaginationState = {
  pageIndex: number;
  pageSize: number;
};

export function paginationAfterFilterOrSortChange(
  previous: TablePaginationState,
): TablePaginationState {
  if (previous.pageIndex === 0) {
    return previous;
  }
  return { ...previous, pageIndex: 0 };
}

export function clampPaginationToPageCount(
  previous: TablePaginationState,
  pageCount: number,
): TablePaginationState {
  if (pageCount <= 0 || previous.pageIndex < pageCount) {
    return previous;
  }
  return { ...previous, pageIndex: Math.max(0, pageCount - 1) };
}
